export const LOCALHOST = "localhost";
export const DEVELOPMENT = "development";
export const QA = "qa";
export const STAGING = "staging";
export const DEMO = "demo";
export const PRODUCTION = "production";

export const ENVIRONMENTS = {
  LOCALHOST,
  DEVELOPMENT,
  QA,
  STAGING,
  DEMO,
  PRODUCTION,
};

export const ANALYTICS_EVENTS = {
  PAGE_VIEW: "page_view",
  SIGN_UP: "sign_up",
  SIGN_IN: "sign_in",
  SIGN_OUT: "sign_out",
  FORGOT_PASSWORD: "forgot",
  SELECT_ITEM: "select_item",
  MENU_ITEM_SELECTED: "menu_item_selected",
  FILE_DOWNLOAD: "file_download",
  APPLY_FILTER: "apply_filter",
  EXPORT: "export",
  DASHBOARD_OPENED: "dashboard_opened",
  CARD_VIEWED: "card_viewed",
  CARD_CLICKED: "card_clicked",
  CARD_POPUP_OPENED: "card_popup_opened",
  CARD_EXPANDED: "card_toggled",
  BUTTON_CLICKED: "button_clicked",
  CHAT_BOT_INTERACTION: "chatbot_interaction",
};

export const CUSTOM_DIMENSIONS = {
  FINANCIAL_INSTITUTION: "financial_institution",
  ORGANIZATION: "organization",
  IDRSSD: "idrssd",
  COHORT: "cohort",
  REGION: "region",
  DASHBOARD: "dashboard",
  NAVIGATED_FROM_CARD: "navigated_from_card",
  USER_ROLE: "user_role",
  USER_ID: "user_id",
  USER_NAME: "user_name",
  SUBSCRIPTION_TYPE: "subscription_type",
  ENVIRONMENT: "environment",
  INSTITUTION_TYPE: "institution_type",
  APPLICATION_VERSION: "application_version",
};

export const ANALYTICS_STORAGE_KEYS = {
  SESSION_ID: "analytics_session_id",
  SESSION_START: "analytics_session_start",
  LOGIN_TIME: "analytics_login_time",
};

export const REGION_FALLBACKS = {
  US: "US",
  CANADA: "Canada",
  INDIA: "India",
  EUROPE: "Europe",
};

export const DEBOUNCE_MS = {
  SCROLL: 800,
  RESIZE: 800,
  MOUSEMOVE: 800,
};

export const DEDUPE_WINDOW_MS = 1200;

const normalizeEnvironmentName = (value = "") => value.toLowerCase().trim();

const getLocationHostname = (location) => {
  if (!location) return "";
  return location.hostname || "";
};

export const isLocalDevelopment = (location = globalThis?.location) => {
  const host = getLocationHostname(location);
  const hostIsLocal =
    host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0";

  return process.env.NODE_ENV === "development" && hostIsLocal;
};

export const resolveEnvironment = () => {
  const fromEnv = normalizeEnvironmentName(process.env.REACT_APP_CURRENT_ENV);
  const fromNode = normalizeEnvironmentName(process.env.NODE_ENV);

  if (fromEnv.includes("localhost")) {
    return ENVIRONMENTS.LOCALHOST;
  }
  if (fromEnv.includes("development")) {
    return ENVIRONMENTS.DEVELOPMENT;
  }
  if (fromEnv.includes("qa")) return ENVIRONMENTS.QA;
  if (fromEnv.includes("staging")) {
    return ENVIRONMENTS.STAGING;
  }
  if (fromEnv.includes("demo")) return ENVIRONMENTS.DEMO;
  if (fromEnv.includes("prod")) return ENVIRONMENTS.PRODUCTION;

  if (fromNode === "production") return ENVIRONMENTS.PRODUCTION;
  if (fromNode === "development") return ENVIRONMENTS.DEVELOPMENT;
  if (fromNode === "test") return ENVIRONMENTS.QA;

  return ENVIRONMENTS.DEVELOPMENT;
};

export const resolveMeasurementId = () => {
  const env = resolveEnvironment();

  const mapping = {
    [ENVIRONMENTS.LOCALHOST]:
      process.env.REACT_APP_GA_MEASUREMENT_ID_LOCALHOST ||
      process.env.REACT_APP_GA_MEASUREMENT_ID,
    [ENVIRONMENTS.DEVELOPMENT]:
      process.env.REACT_APP_GA_MEASUREMENT_ID_DEV ||
      process.env.REACT_APP_GA_MEASUREMENT_ID,
    [ENVIRONMENTS.QA]:
      process.env.REACT_APP_GA_MEASUREMENT_ID_QA ||
      process.env.REACT_APP_GA_MEASUREMENT_ID,
    [ENVIRONMENTS.STAGING]:
      process.env.REACT_APP_GA_MEASUREMENT_ID_STAGING ||
      process.env.REACT_APP_GA_MEASUREMENT_ID,
    [ENVIRONMENTS.DEMO]:
      process.env.REACT_APP_GA_MEASUREMENT_ID_DEMO ||
      process.env.REACT_APP_GA_MEASUREMENT_ID,
    [ENVIRONMENTS.PRODUCTION]:
      process.env.REACT_APP_GA_MEASUREMENT_ID_PROD ||
      process.env.REACT_APP_GA_MEASUREMENT_ID,
  };

  return mapping[env] || "";
};

export default ENVIRONMENTS;
